import { Button as HeadlessButton } from '@headlessui/react'
import clsx from 'clsx'

export function Button({
    children,
    variant = 'primary',
    size = 'large',
    className = '',
    ...props
}) {
    const isDisabled = variant === 'disabled'

    const variants = {
        primary:
            'bg-amber-500 text-white shadow-inner shadow-white/10 hover:bg-yellow-600 focus:outline-yellow-500',
        danger: 'bg-red-600 text-white shadow-inner shadow-white/10 hover:bg-red-700 focus:outline-red-500',
        secondary:
            'bg-white text-gray-900 border border-gray-300 hover:bg-gray-50 focus:outline-yellow-500',
        disabled: 'bg-gray-300 text-gray-500 cursor-not-allowed',
    }

    const sizes = {
        small: 'px-2.5 py-1 text-xs',
        medium: 'px-3 py-1.5 text-sm',
        large: 'px-4 py-2 text-base',
    }

    return (
        <HeadlessButton
            disabled={isDisabled}
            type={props.type || 'button'}
            className={clsx(
                'inline-flex items-center gap-2 rounded-lg font-semibold transition-all duration-100 ease-out focus:outline-none active:scale-95 hover:scale-[1.02] shadow-sm ',
                variants[variant],
                sizes[size],
                className
            )}
            {...props}
        >
            {children}
        </HeadlessButton>
    )
}
